import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for P.F. Candle Co.'s "Amber & Moss - 7.2 oz
// Standard Candle" (p_phqjkpkvyb), pulled from Faire's live
// `GET /api/product-reviews/product/{product_token}` endpoint — verbatim
// comment, real reviewer, real rating, real publish date.
export const review_pfc3: FaireReviewEntity = {
  token: "review_pfc3",
  type: "review",
  brandName: "P.F. Candle Co.",
  brandToken: "b_a9b3b023",
  productToken: "p_phqjkpkvyb",
  reviewType: "product",
  reviewerName: "Michelle Dacosta",
  reviewerLocation: "Fort Lauderdale, FL, United States",
  stars: 5,
  reviewText:
    "Wonderful product, I have one burning at all times at my hair boutique and at home. I get so many compliments about the scent. It always smells divine.",
  reviewDate: "Oct 15, 2024",
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:49:30.000Z",
    importedBy: "entity-db-cli",
  },
};
